<form nz-form [nzLayout]="'horizontal'">
  <nz-spin [nzSpinning]="isLoading">
    <div nz-row nzJustify="center">
      <div nz-col nzFlex="800px">
        <h2 style="text-align: center;">Fleet Inspection</h2>
    <ng-container *ngFor="let field of filterListInspectionData()">
      <nz-form-item>
        <nz-form-label [nzSpan]="6" [nzRequired]="field.isRequired" style="margin-right: 10px">{{ field.fleetInspectionFieldName }} </nz-form-label>
        <nz-form-control [nzErrorTip]="field.fleetInspectionFieldName + ' is required'">
          <nz-input-group [nz-tooltip]="field.tooltipText" [nzTooltipPlacement]="'top'" >
            <input *ngIf="field.dataType==1 || field.dataType == 2" nz-input [type]="'text'" [id]="field.fleetInspectionFieldName" [placeholder]="field.fleetInspectionFieldName" [(ngModel)]="field.fleetInspectionFieldValue" [name]="field.fleetInspectionFieldName" [required]="field.isRequired" (ngModelChange)="isSaved=false">
            <!-- [id]="field.fleetInspectionFieldName" [placeholder]="field.fleetInspectionFieldName" [(ngModel)]="field.fleetInspectionFieldValue" [name]="field.fleetInspectionFieldName" [required]="field.isRequired" (ngModelChange)="isSaved=false" -->
              <input *ngIf="field.dataType==3"
                nz-input
                type="file"
                [id]="field.fleetInspectionFieldName"
                [placeholder]="field.fleetInspectionFieldName"
                [name]="field.fleetInspectionFieldName"
                (change)="onFileSelected($event, field)" 
                accept="image/*,application/pdf"
                (ngModelChange)="isSaved=false">
                <!-- Upload progress indicator -->
                <div *ngIf="isFieldUploading(field.fleetInspectionFieldName)" class="upload-progress">
                  <nz-spin nzSimple></nz-spin>
                  <span style="margin-left: 8px;">Uploading...</span>
                </div>
              <input *ngIf="field.dataType==4"
                nz-input
                type="file"
                [id]="field.fleetInspectionFieldName"
                [placeholder]="field.fleetInspectionFieldName"
                [name]="field.fleetInspectionFieldName"
                (change)="onFileSelected($event, field)" 
                accept="image/*,application/pdf"
                (ngModelChange)="isSaved=false"
                multiple>
                <div *ngIf="isFieldUploading(field.fleetInspectionFieldName)" class="upload-progress">
                <nz-spin nzSimple></nz-spin>
                <span style="margin-left: 8px;">Processing files...</span>
              </div>
              <div *ngIf="field.fleetInspectionFieldValue && !isFieldUploading(field.fleetInspectionFieldName) && (field.dataType==3 || field.dataType==4)" 
              class="file-count">
              {{ field.fleetInspectionFieldValue.length  }} file(s) uploaded
              </div>
          </nz-input-group>
        </nz-form-control>
          <!-- Validation error display -->
        <div *ngIf="getFieldValidationError(field.fleetInspectionFieldName)" 
            class="validation-error">
          {{ getFieldValidationError(field.fleetInspectionFieldName) }}
        </div>
        <!-- <button nz-button  *ngIf="(field.dataType==3 || field.dataType==4) && field.fleetInspectionFieldValue != null " (click)="openFile(field)" style="cursor: pointer; margin-left: 10px;" nz-tooltip="Click to view image" [nzTooltipPlacement]="'top'">
          View Image <span nz-icon nzType="file-jpg" nzTheme="outline" style="margin-left: 5px"> </span>
        </button> -->
        <!-- For dataType 4, display images below the input; otherwise, to the right -->
        <ng-container *ngIf="field.dataType == 4; else rightOfInput">
          <div nz-row style="width: 100%; margin-top: 10px;" nzJustify="end">
            <div *ngFor="let item of field.fleetInspectionFieldValue">
              <img *ngIf="item" [src]="item" alt="{{field.fleetInspectionFieldName}}" style="width: 40px; height: auto; margin-right: 10px;">
            </div>
          </div>
        </ng-container>
        <ng-template #rightOfInput>
          <div style="display: inline-block; vertical-align: middle;">
            <div *ngFor="let item of field.fleetInspectionFieldValue">
              <img *ngIf="(field.dataType==3 || field.dataType==4) && item" [src]="item" alt="{{field.fleetInspectionFieldName}}" style="width: 40px; height: auto; margin-left: 10px;">
            </div>
          </div>
        </ng-template>
      </nz-form-item>
    </ng-container>
      </div>
    </div>
    <nz-table #inspectionTable [nzData]="inspectionDataFields" [nzFrontPagination]="false" [nzShowPagination]="false">
        <thead>
            <tr>
              <th>Tyre Position</th>
              <th *ngFor="let field of inspectionColumns">{{field.fleetInspectionFieldName}}</th>
            </tr>
        </thead>
        <tbody class="table-body">
            <tr *ngFor="let field of inspectionRows">
              <td>{{field.fleetInspectionWheelName}}</td>
              <td *ngFor="let column of inspectionColumns">
                <input
                  #inputElement
                  nz-input
                  placeholder="Enter value"
                  [ngModel]="getCellValue(field.fleetInspectionWheelId, column.fleetInspectionFieldId)"
                  [ngModelOptions]="{standalone: true}"
                  (ngModelChange)="onCellValueChange(field.fleetInspectionWheelId, column.fleetInspectionFieldId, $event)"
                  />
              </td>
            </tr>
        </tbody>
    </nz-table>
    <div nz-row nzJustify="center" style="margin-top: 20px;">
      <div nz-col nzSpan="6">
        <input nz-input placeholder="Enter emails" [defaultValue]="fleetCallCentreEmail" style="width: 90%;" [(ngModel)]="fleetCallCentreEmail" [ngModelOptions]="{standalone: true}"/> 
        <i nz-icon nzType="question-circle" nzTheme="outline" style="margin-left: 8px" [nz-tooltip]="'This email will also be sent to: ' + authService.user.email"></i>
      </div>
      <div nz-col nzSpan="6" nzOffset="12">
        <button nz-button nzType="default">Cancel</button>
        <button nz-button nzType="primary" (click)="saveInspection()" [disabled]="isLoading || !areAllRequiredFieldsFilled()" style="margin-left: 10px;">Save and Send Email</button>
      </div>
    </div>
  </nz-spin>
</form>